/**
 * Google Analytics loader
 */

require("./ga3/loader")
require("./ga4/loader")
